import StatusBadge from './StatusBadge';

export default StatusBadge;